/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../theme/commonStyle";
import { Theme } from "@mui/material";

const guidebookContentStyle = {
  paper: (theme: Theme) => ({
    marginTop: "1rem",
    marginBottom: "1rem",
    maxWidth: "700px",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("sm")]: {
      boxShadow: "none",
    },
  }),
  tableValues: {
    verticalAlign: "top",
    borderBottom: "none",
    color: "primary.main",
    fontSize: "1rem",
    padding: "4px 0px",
  },
  tableValuesRight: {
    minWidth: "80px",
    textAlign: "right",
  },
  tableGuide: {
    width: "100%",
    minWidth: "500px",
    textAlign: "center",
    borderSpacing: "0 .5rem",
    color: "secondary.main",
    "& > tbody > tr > td": {
      width: "25%",
      verticalAlign: "top",
    },
  },
  horizontalScroll: (theme: Theme) => ({
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto",
    },
  }),
  verticalSpace: {
    padding: "1rem 0 0 0",
  },
  downloadButton: {
    color: "primary.main",
  },
  centered: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  primary: {
    color: "primary.main",
  },
  hrPrimary: {
    height: "1px",
    border: 0,
    borderTop: "1px solid",
    borderColor: "primary.main",
  },
  listIntroText: {
    marginBottom: 0,
  },
  bulletList: {
    marginTop: 0,
  },
  scrollToAnchor,
  noSidePadding: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  noPadding: {
    padding: 0,
  },
  subheader: {
    textAlign: "center",
  },
  text: {
    paddingBottom: "40px",
  },
  textTopPadding: {
    paddingTop: "40px",
  },
  link: {
    fontWeight: 400,
    textDecoration: "none",
  },
};

export default guidebookContentStyle;
